define("shared/components/shared/credentials/advanced-display-status/profile-list-item", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "rsvp", "later/errors/index", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _rsvp, _index, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"rsvp",0,"later/errors/index",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tAC--status {{if @success 'tAC--status--success' 'tAC--status--danger'}}">
    {{! Status Info }}
    <div class="u--row u--row--noCollapse">
      {{! User Avatar }}
      <div class="u--col__8">
        <div>
          <Shared::ProfileAvatar @showPlatform={{true}} @socialProfile={{@profile}}>
            <span class="o--user__title u--text--hair {{if @success 'u--text--success' 'u--text--danger'}}">
              {{@profile.nickname}}
            </span>
            <span class="o--user__desc {{if @success 'u--text--success' 'u--text--danger'}}">
              {{t "shared_words.instagram"}}
              {{this.profileType}}
            </span>
          </Shared::ProfileAvatar>
        </div>
      </div>
      {{#if @success}}
        <div class="o--badge--sm o--badge--success u--m__r__0 u--float--right">
          {{t "credentials.status.connected"}}
          {{svg-jar "verified" class="o--icon--sm u--m__l__xs"}}
        </div>
      {{else if (and this.profile.isProfessional this.invalidUserFacebookToken)}}
        <div
          class="o--btn o--btn--outline u--m__r__sm u--float--right u--text--danger"
          {{on "click" (perform this.getConnectedPages)}}
        >
          {{t "shared_words.refresh"}}
          {{svg-jar "refresh" class="o--icon u--m__l__xs"}}
        </div>
      {{else if (or this.isPersonal this.isDisconnected)}}
        <div
          class="o--btn o--btn--outline u--m__r__sm u--float--right u--text--danger"
          {{on "click" (perform this.refreshBusinessOrPersonal)}}
        >
          {{t "shared_words.refresh"}}
          {{svg-jar "refresh" class="o--icon u--m__l__xs"}}
        </div>
      {{else if this.isExpiring}}
        <div class="o--badge--sm o--badge--warning u--m__r__0 u--float--right">
          {{t "credentials.status.expiring" profileType=@profile.accountType}}
          {{svg-jar "danger" class="o--icon--sm u--m__l__xs"}}
        </div>
      {{else}}
        <div class="o--badge--sm o--badge--success u--m__r__0 u--float--right">
          {{t "credentials.status.connected"}}
          {{svg-jar "verified" class="o--icon--sm u--m__l__xs"}}
        </div>
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "7P4OTsQT",
    "block": "[[[10,0],[15,0,[29,[\"tAC--status \",[52,[30,1],\"tAC--status--success\",\"tAC--status--danger\"]]]],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n      \"],[10,0],[12],[1,\"\\n        \"],[8,[39,1],null,[[\"@showPlatform\",\"@socialProfile\"],[true,[30,2]]],[[\"default\"],[[[[1,\"\\n          \"],[10,1],[15,0,[29,[\"o--user__title u--text--hair \",[52,[30,1],\"u--text--success\",\"u--text--danger\"]]]],[12],[1,\"\\n            \"],[1,[30,2,[\"nickname\"]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,1],[15,0,[29,[\"o--user__desc \",[52,[30,1],\"u--text--success\",\"u--text--danger\"]]]],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"shared_words.instagram\"],null]],[1,\"\\n            \"],[1,[30,0,[\"profileType\"]]],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,1],[[[1,\"      \"],[10,0],[14,0,\"o--badge--sm o--badge--success u--m__r__0 u--float--right\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"credentials.status.connected\"],null]],[1,\"\\n        \"],[1,[28,[35,3],[\"verified\"],[[\"class\"],[\"o--icon--sm u--m__l__xs\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,4],[[30,0,[\"profile\",\"isProfessional\"]],[30,0,[\"invalidUserFacebookToken\"]]],null],[[[1,\"      \"],[11,0],[24,0,\"o--btn o--btn--outline u--m__r__sm u--float--right u--text--danger\"],[4,[38,5],[\"click\",[28,[37,6],[[30,0,[\"getConnectedPages\"]]],null]],null],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"shared_words.refresh\"],null]],[1,\"\\n        \"],[1,[28,[35,3],[\"refresh\"],[[\"class\"],[\"o--icon u--m__l__xs\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,7],[[30,0,[\"isPersonal\"]],[30,0,[\"isDisconnected\"]]],null],[[[1,\"      \"],[11,0],[24,0,\"o--btn o--btn--outline u--m__r__sm u--float--right u--text--danger\"],[4,[38,5],[\"click\",[28,[37,6],[[30,0,[\"refreshBusinessOrPersonal\"]]],null]],null],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"shared_words.refresh\"],null]],[1,\"\\n        \"],[1,[28,[35,3],[\"refresh\"],[[\"class\"],[\"o--icon u--m__l__xs\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isExpiring\"]],[[[1,\"      \"],[10,0],[14,0,\"o--badge--sm o--badge--warning u--m__r__0 u--float--right\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"credentials.status.expiring\"],[[\"profileType\"],[[30,2,[\"accountType\"]]]]]],[1,\"\\n        \"],[1,[28,[35,3],[\"danger\"],[[\"class\"],[\"o--icon--sm u--m__l__xs\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"o--badge--sm o--badge--success u--m__r__0 u--float--right\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"credentials.status.connected\"],null]],[1,\"\\n        \"],[1,[28,[35,3],[\"verified\"],[[\"class\"],[\"o--icon--sm u--m__l__xs\"]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]],[]]]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@success\",\"@profile\"],false,[\"if\",\"shared/profile-avatar\",\"t\",\"svg-jar\",\"and\",\"on\",\"perform\",\"or\"]]",
    "moduleName": "shared/components/shared/credentials/advanced-display-status/profile-list-item.hbs",
    "isStrictMode": false
  });
  let ProfileListItemComponent = _exports.default = (_dec = (0, _service.inject)('social/facebook-auth'), _dec2 = (0, _service.inject)('social/instagram-business'), (_class = class ProfileListItemComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "credentialStatus", _descriptor4, this);
      _initializerDefineProperty(this, "facebookAuth", _descriptor5, this);
      _initializerDefineProperty(this, "instagramBusiness", _descriptor6, this);
      _initializerDefineProperty(this, "instagram", _descriptor7, this);
      _initializerDefineProperty(this, "intl", _descriptor8, this);
      _initializerDefineProperty(this, "lastRefresh", _descriptor9, this);
      _defineProperty(this, "refreshBusinessToken", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function () {
          var _this = this;
          let onError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};
          return function* () {
            const originalMissingFeatures = [..._this.args.originalMissingFeatures];
            const originalProfiles = [..._this.args.originalProfiles];
            const onSuccess = () => _this.args.onSuccess(originalMissingFeatures, originalProfiles);
            try {
              yield _this.facebookAuth.authenticateFacebook(_this.instagramBusiness.potentialScopes);
            } catch (error) {
              _this.alerts.warning(_this.intl.t('shared_phrases.try_again'));
              return;
            }
            try {
              yield _this.instagramBusiness.refreshBusinessAccountEndpoint(_this.profile, _this.args.source, onSuccess);
            } catch (error) {
              if (_this.auth.currentUserModel.facebookToken) {
                // Note: If the catch block in refreshBusinessAccountEndpoint hasn't fired, handle
                // the the failed refresh here.
                yield _this.instagramBusiness.handleFailedRefresh.perform(_this.profile);
              }
              if (error instanceof _index.CredentialsNotFoundError) {
                error.resolve.call(_this, _this.profile);
              } else if (error instanceof _index.RequestError) {
                error.resolve.call(_this);
              } else {
                onError();
                _this.errors.log(`refreshBusinessToken error: ${error}`, {
                  socialProfileId: _this.profile?.id || 'Invalid social profile'
                });
                return;
              }
            }
          }();
        }
      }), null, "refreshBusinessToken", null));
      _defineProperty(this, "getConnectedPages", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            const originalMissingFeatures = [...this.args.originalMissingFeatures];
            const originalProfiles = [...this.args.originalProfiles];
            // Note: instagramBusiness.getConnectedPages will return {} in the event of an
            // error, so it will not trigger the catch block.
            const connectedPageData = yield this.instagramBusiness.getConnectedPages.perform(this.profile);
            if (!Object.keys(connectedPageData).length) {
              return this.args.onError();
            }
            this.credentialStatus.successfulRefresh = true;
            this.args.onSuccess(originalMissingFeatures, originalProfiles);
          } catch (error) {
            this.errors.log(`getConnectedPages error: ${error}`);
            this.args.onError();
          }
        }
      }), null, "getConnectedPages", null));
      _defineProperty(this, "refreshBusinessOrPersonal", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const originalProfiles = [...this.args.originalProfiles];
          const originalMissingFeatures = [...this.args.originalMissingFeatures];
          const shouldRefreshProfessionalToken = (this.profile.isProfessional || this.profile.needsProfessionalTokenRefresh) && this.lastRefresh !== 'businessToken';
          try {
            if (this.profile.needsBasicDisplayTokenRefresh) {
              this.lastRefresh = 'token';
              yield this.refreshToken();
            } else if (shouldRefreshProfessionalToken) {
              this.lastRefresh = 'businessToken';
              // Note: refreshBusinessToken will catch any errors that occur, which will prevent them from
              // hitting the catch block below, so we pass in a function to handle the error.
              yield this.refreshBusinessToken.perform(this.args.onError);
              yield this.profile.save();
            } else {
              this.lastRefresh = 'token';
              yield this.refreshToken();
            }
            this.credentialStatus.successfulRefresh = true;
            this.args.onSuccess(originalMissingFeatures, originalProfiles);
            this.credentialStatus.checkBrokenProfiles();
          } catch (error) {
            this.errors.log(`refreshBusinessOrPersonal error: ${error}`, {
              socialProfileId: this.profile?.id || 'Invalid social profile'
            });
            this.args.onError();
          }
        }
      }), null, "refreshBusinessOrPersonal", null));
    }
    get invalidUserFacebookToken() {
      return this.credentialStatus.invalidUserFacebookToken;
    }
    get profile() {
      return this.args.profile;
    }
    get isDisconnected() {
      return this.profile.hasUnconnectedProfessional || this.profile.needsProfessionalTokenRefresh || this.profile.needsBasicDisplayTokenRefresh;
    }
    get hasUnconnectedProfessional() {
      return this.profile.hasUnconnectedProfessional && !this.revokePermissions.isRunning;
    }
    get isExpiring() {
      return this.profile.instagramBusinessTokenExpiring;
    }
    get needsRefresh() {
      return this.profile.needsRefresh;
    }
    get isCreator() {
      return this.profile.isCreator;
    }
    get isPersonal() {
      return !this.profile.isProfessional;
    }
    get cannotAutoPublish() {
      return this.isPersonal;
    }
    get needsProfessionalUpdate() {
      return this.profile.isProfessional && !this.profile.hasProfessionalAccount;
    }
    get profileType() {
      if (this.isPersonal) {
        return 'Personal';
      } else if (this.isCreator) {
        return 'Creator';
      }
      return 'Business';
    }
    refreshToken() {
      return new _rsvp.default.Promise((resolve, reject) => {
        const {
          profile
        } = this;
        const isRefresh = true;
        this.instagram.loginInstagram(profile, isRefresh).then(auth => {
          const response = [auth.uid, auth.credentials.token, auth.scope];
          return Promise.all([...response, this.instagram.fetchBasicDisplayUsername(auth.credentials.token)]);
        }).then(_ref => {
          let [uid, accessToken, scope, username] = _ref;
          if (uid === profile.uid || username === profile.nickname) {
            this.instagramBusiness.updateSocialProfile.perform(profile, accessToken, scope, uid);
            resolve(profile);
          } else {
            this.alerts.warning(this.intl.t('alerts.account.controllers.groups.wrong_profile', {
              social_profile: profile.nickname,
              username
            }));
            reject('The correct Instagram Profile was not found');
          }
        }).catch(error => {
          if (error) {
            this.errors.log(`ads/refreshToken error: ${error}`);
          }
          reject('Could not login to Instagram');
        });
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "credentialStatus", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "facebookAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "instagram", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "lastRefresh", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "refreshToken", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshToken"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProfileListItemComponent);
});